import { ContractDoctor } from '../interfaces/doctor'
import { UserState } from './user.state'
import { isDoctor } from './user.type-guards'

export class UserSelectors {
  static selectUserToken(state: UserState) {
    return state.token
  }
  static selectRefreshToken(state: UserState) {
    return state.refreshToken
  }
  static selectCsrfToken(state: UserState) {
    return state.csrfToken
  }
  static selectUser(state: UserState) {
    return state.user
  }

  static selectDoctorUserBaseId(state: UserState): number | string | null {
    const user = state.user
    if (!isDoctor(user)) return null
    const id = (user as any).userBaseId ?? (user as any).id
    if (id == null) return null
    const asNumber = Number(id)
    return Number.isFinite(asNumber) ? asNumber : String(id)
  }

  static selectUserContracts(state: UserState): ContractDoctor[] | null {
    const user = state.user

    if (!isDoctor(user)) return null
    return user.contractDoctors ?? null
  }
  static selectIsAuthenticated(state: UserState) {
    return !!state.user
  }

  static selectIsLoading(state: UserState) {
    return state.isLoading
  }

  static selectError(state: UserState) {
    return state.error
  }

  static selectMfaToken(state: UserState) {
    return state.mfaToken
  }

  static selectPasswordExpiredEmail(state: UserState) {
    return state.passwordExpiredEmail
  }
}
